<template>
  <header class="sd-header w-100">
    <div class="header-container-top dashboard" v-if="route.includes('dashboard')">
      <div class="container-fluid w-auto">
        <div class="left-side">
          <div class="derect-logo">
            <svg-icon icon="derect_logo" class-name="derect-logo" />
          </div>
        </div>
        <div class="right-side">
          <div v-if="user" class="position-relative options">
            <router-link
              v-if="user.avatar"
              :to="{ name: user.type == 2 ? 'company-edit' : 'applicant-edit' }"
              class="d-block profile-img"
              :style="user ? this.ImageBackground($store.state.user_avatar):''"
            ><svg-icon icon="gear" /></router-link>
            <router-link
              v-if="!user.avatar"
              :to="{ name: user.type == 2 ? 'company-edit' : 'applicant-edit' }"
              class="d-block"
            >
              <svg-icon icon="person_male" class="full-height" />
              <svg-icon icon="gear"/>
            </router-link>
          </div>
          <a title="Menu" class="toggle-nav" v-if="logged_in">
            <label hidden>Menu</label>
            <svg-icon icon="hamburger"/>
          </a>
        </div>
      </div>
    </div>
    <div class="header-container-top dashboard" v-else-if="route.includes('about')">
      <div class="container-fluid w-auto">
        <div class="left-side">
          <router-link :to="{ name: 'login' }" class="go-back">
            <svg-icon icon="arrow_w" />
          </router-link>
          <h1 v-if="page_title" class="sd-title small bold text-brown position-relative">
            {{ page_title }}
          </h1>
        </div>
        <div class="right-side">
        </div>
      </div>
    </div>
    <div class="header-container-top" v-else>
      <div class="container-fluid w-auto">
        <div class="left-side">
          <GoBack class="" :link="link" v-if="logged_in && !doNotShowAll"/>
          <h1 v-if="page_title" class="sd-title small bold text-brown position-relative">
            {{ page_title }}
          </h1>
          <div v-if="!page_title" class="derect-logo">
            <svg-icon icon="derect_logo" class-name="derect-logo" />
          </div>
        </div>
        <div class="right-side" v-if="logged_in && !doNotShowAll">
          <div v-if="user" class="position-relative options">
            <router-link
              v-if="user.avatar"
              :to="{ name: user.type == 2 ? 'company-edit' : 'applicant-edit' }"
              class="d-block profile-img"
              :style="user ? this.ImageBackground($store.state.user_avatar):''"
            ><svg-icon icon="gear" /></router-link>
            <router-link
              v-if="!user.avatar"
              :to="{ name: user.type == 2 ? 'company-edit' : 'applicant-edit' }"
              class="d-block"
            >
              <svg-icon icon="person_male" class="full-height" />
              <svg-icon icon="gear"/>
            </router-link>
          </div>
          <a title="Menu" class="toggle-nav" v-if="logged_in">
            <label hidden>Menu</label>
            <svg-icon icon="hamburger"/>
          </a>
        </div>
      </div>
    </div>
    <svg-icon icon="wave2" className="wave dashboard" v-if="route.includes('dashboard')"/>
    <svg-icon icon="wave" className="wave" v-else />
  </header>
</template>

<script>
export default {
  data: function() {
    return {
      logged_in: this.isUserActiveLoggedIn(),
      route: window.location.href,
      user_token: "",
      user: "",
    };
  },
  props: {
    page_title: {
      type: String,
      default: ""
    },
    menuClass: String,
    link: Object,
    goBackClass: String,
    doNotShowAll: Boolean
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    navState: async function() {
      await this.fetchData();
    },
    $route: "fetchData"
  },
  methods: {
    gotoDashboard() {
      const user = JSON.parse(localStorage.getItem("user"));
      if(user) {
        if(user.type == 1) {
          this.$router.replace({
              name: "applicant-dashboard"
        }).catch(() => {});
        } else {
          this.$router.replace({
              name: "company-dashboard"
        }).catch(() => {});
        }
      } else {
        this.$router.replace({
          name: "login"
        });
      }
    },
    async fetchData() {
      this.user_token = JSON.parse(localStorage.getItem("user-token"));
      this.user = JSON.parse(localStorage.getItem("user"));

      if (this.user_token == null)
        this.user_token = "";

      if (this.user == null)
        this.user = "";

      if(this.user)
        this.$store.state.user_avatar = this.user.avatar;
    }
  }
};
</script>

<style scoped>
.go-back a {
  color: #64513D;
}
</style>
